import React from 'react';
import { useNavigate } from 'react-router-dom';

const AccessDeniedPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', minHeight: '60vh', gap: '16px', textAlign: 'center', padding: '24px'
    }}>
      <div style={{ fontSize: '48px' }}>🔒</div>
      <h2 style={{ margin: 0, color: '#111827', fontSize: '22px', fontWeight: 600 }}>Access Denied</h2>
      <p style={{ margin: 0, color: '#6b7280', maxWidth: '380px' }}>
        You don't have permission to view this page. Contact your administrator to request access.
      </p>
      <button
        onClick={() => navigate('/dashboard')}
        style={{
          marginTop: '8px', padding: '10px 24px', background: '#4f46e5',
          color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer',
          fontSize: '14px', fontWeight: 500
        }}
      >
        Back to Dashboard
      </button>
    </div>
  );
};

export default AccessDeniedPage;
